import React from 'react';

function ComponentLoading(props: Props) {
  const { styles } = props;
  if (!styles) {
    return (
      <div className="loading--height">
        <div className="col__1-1 u--paddingNormal u__text-align--center loading--center">
          <span className="segment-spinner" />
        </div>
      </div>
    );
  }
  return <span style={{ ...styles }} className="segment-spinner " />;
}

// TODO: could be modified to take in a specified height with a default of 50vh,
// but inilne styles hurt performance
// function ComponentLoading({ height }) {
//   return (
//     <div style={{ height}}>
//       ...
//     </div>
//   )
// }
// ComponentLoading.defaultProps = {
//   height: '50vh';
// }

export default ComponentLoading;
